export function emptyRows(page, rowsPerPage, arrayLength) {
    return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - arrayLength) : 0;
  }